export function setCookie(contact_name) {
  let expires = `expires=${new Date(new Date().getTime()+1000*60*60*24*365).toGMTString()}`
  document.cookie = `submitted=true;${expires}`
  document.cookie = `contact_name=${contact_name}`
}

export function getCookie() {
  let cookies = document.cookie.split('; ');
  let submitted = cookies.find((row) => row.startsWith('submitted='))
  let contact_name = cookies.find((row) => row.startsWith('contact_name='))
  contact_name = contact_name && contact_name.length > 0 ? contact_name.split('=')[1] : null
  submitted = submitted ? submitted.split('=')[1] : false
  return { contact_name, submitted }
}


// WEBPACK FOOTER //
// ./src/helpers/cookie.js